'use client';

import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';
import { Responsive, UnstyledUl } from '../../../ui';

export interface ICardsContainer {
	columns?: number;
	children: ReactNode;
}

export default function CardsContainer({ columns, children }: ICardsContainer) {
	return (
		<StyledCardsContainer columns={columns} className="cards-container">
			{children}
		</StyledCardsContainer>
	);
}

export const StyledCardsContainer = styled(UnstyledUl)<{
	columns?: number;
}>`
	display: grid;
	grid-column-gap: ${theme.grid?.gutter?.vertical?.default};
	grid-row-gap: ${theme.grid?.gutter?.horizontal?.default};
	padding: 0;
	margin: 0;
	grid-template-columns: ${({ columns }) =>
		columns ? `repeat(${columns}, 1fr)` : `repeat(3, 1fr)`};

	li {
		margin-top: 0;
		min-width: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-template-columns: 1fr;
		grid-row-gap: ${theme.grid?.gutter?.horizontal?.mobile};
	}
`;
